// educationServices.js

import apiClient from './apiClient';
export { fetchAnnouncements, fetchCommunications, fetchGuests, fetchDiaryEntries } from './commonServices';

export const fetchAttachments = async () => {
    const response = await apiClient.get('/attachments.php?action=getVisible');
    return response.data;
};
